import { ButtonType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { createCollectionAndShowToasts } from '~src/Collections/sagas/CollectionSagas';
import { ButtonWithSpinner } from '~src/commonInfra/components/ButtonWithSpinner';
import { Location } from '~src/commonInfra/utils/Location';
import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';

import { CollectionsResourceQuery } from '../ResourceQuery/CollectionsResourceQuery';
import { CreateCollectionClickedSourceOptions,sendCreateCollectionClickedTelemetry } from './CollectionsTelemetry';

export interface NewCollectionButtonProps {
  readonly urls: SpacesSiteUrls;
  readonly userDisplayName: string;
}

export function NewCollectionButton(props: NewCollectionButtonProps): JSX.Element {
  const [busyCreatingCollection, setBusyCreatingCollection] = React.useState<boolean>(false);

  const createCollection = async () => {
    setBusyCreatingCollection(true);

    const urls = props.urls;
    const resource = new CollectionsResourceQuery();
    const currentUrl = Location.instance.href();
    const userDisplayName = props.userDisplayName;
    await createCollectionAndShowToasts(resource, urls, currentUrl, userDisplayName);
    setBusyCreatingCollection(false);
  };

  return (
    <ButtonWithSpinner
      onClick={() => {
        sendCreateCollectionClickedTelemetry('collections', CreateCollectionClickedSourceOptions.NewCollectionButton);
        createCollection();
      }}
      children={Messages.createCollectionButtonLabel()}
      buttonType={ButtonType.Outline}
      testId={'new-collection-button'}
      showSpinner={busyCreatingCollection}
    />
  );
}
